import { ColumnChart } from '..'

const CATEGORIES = [
  '1 - 1.25%',
  '1.25 - 1.5%',
  '1.5 - 1.75%',
  '1.75 - 2%',
  '2 - 2.25%',
  '2.25 - 2.5%',
  '2.5 - 2.75%',
  '2.75 - 3%'
]

const TOOLTIP_FORMATTER = that => {
  const { category, y: trades } = that.point as any

  return `<div class="column-chart-tooltip-wrapper"><h2>${category}</h2><p>Trades: ${trades}</p></div>`
}

interface Props {
  leverageRatios: { x: number; y: number }[]
}
export const LeverageRatioColumnChart = ({ leverageRatios }: Props) => (
  <ColumnChart categories={CATEGORIES} data={leverageRatios} tooltipFormatter={TOOLTIP_FORMATTER} />
)
